import { createUseStyles } from 'react-jss';

import colors from "../../../../utils/colors";

var styles = {
  attributeCell: {
    border: "0.1rem solid ".concat(colors.neutral[300]),
    borderLeft: 'none',
    '&:last-child': {
      borderRight: 'none'
    }
  },
  attributeValueCell: function attributeValueCell(showWideColumns) {return {
      width: showWideColumns ? '40rem' : '34rem',
      fontSize: '1.4rem',
      lineHeight: '2rem',
      padding: '1.5rem 1rem'
    };},
  selectedPortfolio: {
    backgroundColor: colors.green[100]
  },
  disabledCell: {
    backgroundColor: colors.neutral[100],
    filter: 'grayscale(1)',
    opacity: '0.6'
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map